module.exports = __webpack_public_path__ + "static/media/termet.3d3b3533.png";